import { apiBaseUrl } from 'yxt-biz-pc/packages/api';
/**
 * 获取标签审核详情
 */
export const getDeatilApi = (id) => {
  return apiBaseUrl.get(`/spmodel/mgr/label/audit/${id}`);
};
